import styles from './Suggestions.module.scss'

export default function Suggestions({ callback }) {
  return (
    <section className="container">
      <div className={styles.wrap}>
        <p className={styles.infoText}>
          Näyttää siltä ettei enempää tuloksia ole. Haluaisitko etsiä muita
          palveluita?
        </p>

        <p
          className={styles.expandSearch}
          onClick={() => callback(true)}
          role="button"
        >
          Laajenna hakua
        </p>
      </div>
    </section>
  )
}
